<template>
  <main
    id="create-item-page"
    class="page-container"
    v-if="$route.name === 'listini-add-item'"
  >
    <button type="button" class="back-btn" @click="goBack">
      <i class="fa-solid fa-arrow-left"></i> Indietro
    </button>
    <form class="create-item-form" @submit.prevent="onSubmit">
      <!-- ── Campi comuni ─────────────────────────────────────────── -->
      <div class="create-item-row">
        <div class="field">
          <label for="item-code">Codice articolo</label>
          <input
            id="item-code"
            type="text"
            v-model.trim="form.itemCode"
            placeholder="es. ART-001"
            maxlength="255"
          />
          <small style="color: #718096; font-size: 0.75rem"
            >Facoltativo: può essere lasciato vuoto.</small
          >
        </div>
        <div class="field">
          <label for="item-name">Nome articolo *</label>
          <input
            id="item-name"
            type="text"
            v-model.trim="form.itemName"
            placeholder="inserisci"
            required
          />
        </div>
      </div>

      <div class="create-item-row">
        <div class="field">
          <label for="brand">Brand</label>
          <input
            id="brand"
            type="text"
            v-model="form.brand"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="serie">Serie</label>
          <input
            id="serie"
            type="text"
            v-model="form.serie"
            placeholder="inserisci"
          />
        </div>
        <div class="field" v-if="category !== 'piastrelle'">
          <label for="price">Prezzo — IVA esclusa</label>
          <input
            id="price"
            type="number"
            step="any"
            min="0"
            v-model.number="form.price"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="articleStatus">Stato</label>
          <StatusSelect
            v-model="form.articleStatus"
            :options="articleStatusOptions"
          />
        </div>
      </div>

      <hr />

      <!-- ── Gruppo AREA ── -->
      <template v-if="categoryGroup === 'area'">
        <!-- Piastrelle: selezione tipologia + campi variabili -->
        <template v-if="category === 'piastrelle'">
          <div class="create-item-row">
            <div class="field">
              <label>Tipologia *</label>
              <StatusSelect
                v-model="form.subCategory"
                :options="subCategoryOptions"
                placeholder="Seleziona tipologia..."
                placeholderIcon="fa-tag"
              />
            </div>
          </div>

          <!-- Elementi Lineari (ML) -->
          <template v-if="tileGroup === 'linear'">
            <div class="create-item-row">
              <div class="field">
                <label for="formatLabel">Formato</label>
                <input
                  id="formatLabel"
                  type="text"
                  v-model="form.formatLabel"
                  placeholder="es. 60x120"
                />
              </div>
              <div class="field">
                <label for="thicknessMm">Spessore (mm)</label>
                <input
                  id="thicknessMm"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="form.thicknessMm"
                  placeholder="es. 10"
                />
              </div>
              <div class="field">
                <label for="finish">Finitura</label>
                <input
                  id="finish"
                  type="text"
                  v-model="form.finish"
                  placeholder="inserisci"
                />
              </div>
              <div class="field">
                <label for="mlPerBox">ML / scatola</label>
                <input
                  id="mlPerBox"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="form.mlPerBox"
                  placeholder="es. 2.5"
                />
              </div>
            </div>
          </template>

          <!-- Decori / Fondi (M2) -->
          <template v-else-if="tileGroup === 'area'">
            <div class="create-item-row">
              <div class="field">
                <label for="formatLabel">Formato</label>
                <input
                  id="formatLabel"
                  type="text"
                  v-model="form.formatLabel"
                  placeholder="es. 60x120"
                />
              </div>
              <div class="field">
                <label for="widthCm">Larghezza (cm)</label>
                <input
                  id="widthCm"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="form.widthCm"
                  placeholder="inserisci"
                />
              </div>
              <div class="field">
                <label for="heightCm">Altezza (cm)</label>
                <input
                  id="heightCm"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="form.heightCm"
                  placeholder="inserisci"
                />
              </div>
              <div class="field">
                <label for="thicknessMm">Spessore (mm)</label>
                <input
                  id="thicknessMm"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="form.thicknessMm"
                  placeholder="es. 10"
                />
              </div>
              <div class="field">
                <label for="finish">Finitura</label>
                <input
                  id="finish"
                  type="text"
                  v-model="form.finish"
                  placeholder="inserisci"
                />
              </div>
              <div class="field">
                <label for="sqmPerBox">M² / scatola</label>
                <input
                  id="sqmPerBox"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="form.sqmPerBox"
                  placeholder="es. 1.44"
                />
              </div>
            </div>
          </template>

          <!-- Battiscopa / Listelli / Gradini / Scalini / Altri Pezzi Speciali (PZ) -->
          <template v-else-if="tileGroup === 'piece'">
            <div class="create-item-row">
              <div class="field">
                <label for="formatLabel">Formato</label>
                <input
                  id="formatLabel"
                  type="text"
                  v-model="form.formatLabel"
                  placeholder="es. 60x120"
                />
              </div>
              <div class="field">
                <label for="thicknessMm">Spessore (mm)</label>
                <input
                  id="thicknessMm"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="form.thicknessMm"
                  placeholder="es. 10"
                />
              </div>
              <div class="field">
                <label for="finish">Finitura</label>
                <input
                  id="finish"
                  type="text"
                  v-model="form.finish"
                  placeholder="inserisci"
                />
              </div>
              <div class="field">
                <label for="sqmPerBox">M² / scatola</label>
                <input
                  id="sqmPerBox"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="form.sqmPerBox"
                  placeholder="es. 1.44"
                />
              </div>
            </div>
          </template>

          <!-- Pz/scatola comune a tutti i tileGroup (la giacenza si
               gestisce dal magazzino, non dalla scheda articolo) -->
          <template v-if="tileGroup">
            <div class="create-item-row">
              <div class="field">
                <label for="piecesPerBox">Pz / scatola</label>
                <input
                  id="piecesPerBox"
                  type="number"
                  min="0"
                  v-model.number="form.piecesPerBox"
                  placeholder="inserisci"
                />
              </div>
            </div>
            <div class="create-item-row">
              <div class="field">
                <label for="price">{{ priceLabel }} — IVA esclusa</label>
                <input
                  id="price"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="form.price"
                  placeholder="inserisci"
                />
              </div>
            </div>
          </template>
        </template>

        <!-- Parquet -->
        <template v-else-if="category === 'parquet'">
          <div class="create-item-row">
            <div class="field">
              <label for="material">Materiale (specie legnosa)</label>
              <StatusSelect
                v-model="form.material"
                :options="parquetMaterialOptions"
                placeholder="Seleziona specie..."
                placeholderIcon="fa-tree"
              />
            </div>
            <div class="field">
              <label for="finish">Finitura (lavorazione)</label>
              <input
                id="finish"
                type="text"
                v-model="form.finish"
                placeholder="es. Spazzolato naturale"
              />
            </div>
            <div class="field">
              <label for="scelta">Scelta</label>
              <StatusSelect
                v-model="form.specs.scelta"
                :options="parquetSceltaOptions"
                placeholder="Seleziona scelta..."
                placeholderIcon="fa-shapes"
              />
            </div>
          </div>
          <div class="create-item-row">
            <div class="field">
              <label for="formatLabel">Formato</label>
              <input
                id="formatLabel"
                type="text"
                v-model="form.formatLabel"
                placeholder="es. 65-70x440-490 mm"
              />
            </div>
            <div class="field">
              <label for="thicknessMm">Spessore (mm)</label>
              <input
                id="thicknessMm"
                type="number"
                step="any"
                min="0"
                v-model.number="form.thicknessMm"
                placeholder="es. 10"
              />
            </div>
            <div class="field">
              <label for="widthCm">Larghezza (cm)</label>
              <input
                id="widthCm"
                type="number"
                step="any"
                min="0"
                v-model.number="form.widthCm"
                placeholder="es. 6.5"
              />
            </div>
            <div class="field">
              <label for="lengthMm">Lunghezza (mm)</label>
              <input
                id="lengthMm"
                type="number"
                step="any"
                min="0"
                v-model.number="form.lengthMm"
                placeholder="es. 440"
              />
            </div>
          </div>
          <!-- Dati imballo: senza M²/scatola l'articolo non è preventivabile
               (la quantità in mq non è convertibile in scatole) -->
          <div class="create-item-row">
            <div class="field">
              <label for="sqmPerBox">M² / scatola</label>
              <input
                id="sqmPerBox"
                type="number"
                step="any"
                min="0"
                v-model.number="form.sqmPerBox"
                placeholder="es. 2.13"
              />
            </div>
            <div class="field">
              <label for="piecesPerBox">Pz / scatola</label>
              <input
                id="piecesPerBox"
                type="number"
                min="0"
                v-model.number="form.piecesPerBox"
                placeholder="inserisci"
              />
            </div>
          </div>
        </template>

        <!-- Altre categorie area (rivestimenti parete, ecc.) -->
        <template v-else>
          <div class="create-item-row">
            <div class="field">
              <label for="formatLabel">Formato (es. 60x120)</label>
              <input
                id="formatLabel"
                type="text"
                v-model="form.formatLabel"
                placeholder="es. 60x120"
              />
            </div>
            <div class="field">
              <label for="widthCm">Larghezza (cm)</label>
              <input
                id="widthCm"
                type="number"
                step="any"
                min="0"
                v-model.number="form.widthCm"
                placeholder="inserisci"
              />
            </div>
            <div class="field">
              <label for="heightCm">Altezza (cm)</label>
              <input
                id="heightCm"
                type="number"
                step="any"
                min="0"
                v-model.number="form.heightCm"
                placeholder="inserisci"
              />
            </div>
            <div class="field">
              <label for="thicknessMm">Spessore (mm)</label>
              <input
                id="thicknessMm"
                type="number"
                step="any"
                min="0"
                v-model.number="form.thicknessMm"
                placeholder="es. 10"
              />
            </div>
            <div class="field">
              <label for="surface">Superficie</label>
              <input
                id="surface"
                type="text"
                v-model="form.surface"
                placeholder="es. Matt, Lucido"
              />
            </div>
            <div class="field">
              <label for="color">Colore</label>
              <input
                id="color"
                type="text"
                v-model="form.color"
                placeholder="inserisci"
              />
            </div>
          </div>
          <div class="create-item-row">
            <div class="field">
              <label for="sqmPerBox">M² / scatola</label>
              <input
                id="sqmPerBox"
                type="number"
                step="any"
                min="0"
                v-model.number="form.sqmPerBox"
                placeholder="es. 1.44"
              />
            </div>
            <div class="field">
              <label for="piecesPerBox">Pz / scatola</label>
              <input
                id="piecesPerBox"
                type="number"
                min="0"
                v-model.number="form.piecesPerBox"
                placeholder="inserisci"
              />
            </div>
          </div>
        </template>
      </template>

      <!-- ── Gruppo PIECE ── -->
      <template v-if="categoryGroup === 'piece'">
        <div class="create-item-row">
          <div v-if="category === 'sanitari'" class="field">
            <label for="fixtureType">Tipo</label>
            <StatusSelect
              v-model="form.fixtureType"
              :options="fixtureTypeOptions"
            />
          </div>
          <div v-if="category === 'sanitari'" class="field">
            <label for="fixturePosition">Posizione</label>
            <StatusSelect
              v-model="form.fixturePosition"
              :options="fixturePositionOptions"
            />
          </div>
          <div class="field">
            <label for="finish">Finitura</label>
            <input
              id="finish"
              type="text"
              v-model="form.finish"
              placeholder="es. Cromo, Nero opaco"
            />
          </div>
          <div class="field">
            <label for="color">Colore</label>
            <input
              id="color"
              type="text"
              v-model="form.color"
              placeholder="inserisci"
            />
          </div>
        </div>
      </template>

      <!-- ── Gruppo LINEAR ── -->
      <template v-if="categoryGroup === 'linear'">
        <div class="create-item-row">
          <div class="field">
            <label for="material">Materiale</label>
            <input
              id="material"
              type="text"
              v-model="form.material"
              placeholder="es. Alluminio, Inox"
            />
          </div>
          <div class="field">
            <label for="lengthMm">Lunghezza (mm)</label>
            <input
              id="lengthMm"
              type="number"
              step="any"
              min="0"
              v-model.number="form.lengthMm"
              placeholder="es. 2500"
            />
          </div>
          <div class="field">
            <label for="mlPerBox">ML / confezione</label>
            <input
              id="mlPerBox"
              type="number"
              step="any"
              min="0"
              v-model.number="form.mlPerBox"
              placeholder="es. 2.5"
            />
          </div>
        </div>
      </template>

      <!-- ── Gruppo FURNITURE ── -->
      <template v-if="categoryGroup === 'furniture'">
        <div class="create-item-row">
          <div class="field">
            <label for="widthCm">Larghezza (cm)</label>
            <input
              id="widthCm"
              type="number"
              step="any"
              min="0"
              v-model.number="form.widthCm"
              placeholder="inserisci"
            />
          </div>
          <div class="field">
            <label for="heightCm">Altezza (cm)</label>
            <input
              id="heightCm"
              type="number"
              step="any"
              min="0"
              v-model.number="form.heightCm"
              placeholder="inserisci"
            />
          </div>
          <div class="field">
            <label for="material">Materiale</label>
            <input
              id="material"
              type="text"
              v-model="form.material"
              placeholder="es. MDF, Rovere"
            />
          </div>
          <div class="field">
            <label for="finish">Finitura</label>
            <input
              id="finish"
              type="text"
              v-model="form.finish"
              placeholder="es. Bianco opaco"
            />
          </div>
        </div>
      </template>

      <!-- ── Gruppo BATH (bagno) ── -->
      <template v-if="categoryGroup === 'bath'">
        <div class="create-item-row">
          <div class="field">
            <label>Tipologia</label>
            <input
              type="text"
              :value="form.subCategory"
              readonly
              placeholder="—"
            />
          </div>
        </div>
      </template>

      <!-- ── Gruppo GENERIC ── -->
      <template v-if="categoryGroup === 'generic'">
        <div class="create-item-row">
          <div class="field">
            <label for="notes">Note</label>
            <textarea
              id="notes"
              v-model="form.notes"
              placeholder="inserisci"
              rows="3"
            />
          </div>
        </div>
      </template>

      <hr />

      <div class="save-button-container">
        <button
          id="create-item-button"
          class="primary-btn"
          type="submit"
          :disabled="!canSave"
          :aria-disabled="!canSave"
          :title="!canSave ? 'Inserisci il nome articolo' : 'Salva articolo'"
        >
          Salva
        </button>
      </div>
    </form>

    <VueFinalModal
      v-model="showBackModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="showBackModal = false"
          title="Chiudi"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="modal__title">Tornare indietro?</h3>
        <p class="modal__subtitle">Le modifiche non salvate andranno perse.</p>
        <div class="modal-actions">
          <button class="secondary-btn" @click="showBackModal = false">
            Annulla
          </button>
          <button class="primary-btn confirm-btn" @click="confirmGoBack">
            Conferma
          </button>
        </div>
      </template>
    </VueFinalModal>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import StatusSelect from "@/components/StatusSelect.vue";

const COLUMN_GROUPS = {
  area: [
    "piastrelle",
    "rivestimenti parete",
    "parquet",
    "laminati",
    "decking esterno",
  ],
  piece: ["sanitari", "rubinetteria", "box doccia", "accessori bagno"],
  linear: ["profili", "sistemi di scarico"],
  furniture: ["mobili", "porte e infissi"],
  bath: ["bagno"],
};

function getCategoryGroup(category) {
  for (const [group, cats] of Object.entries(COLUMN_GROUPS)) {
    if (cats.includes(category)) return group;
  }
  return "generic";
}

export default {
  name: "CreateItemPage",
  components: { StatusSelect },
  beforeRouteLeave(to) {
    if (
      this.navigationConfirmed ||
      to.name === "login" ||
      !this.hasUnsavedChanges
    ) {
      this.navigationConfirmed = false;
      return true;
    }
    this.pendingNavigation = to;
    this.showBackModal = true;
    return false;
  },
  data() {
    return {
      showBackModal: false,
      pendingNavigation: null,
      navigationConfirmed: false,
      pristineFormSig: "", // snapshot del form iniziale, per rilevare modifiche
      articleStatusOptions: [
        { value: "attivo", label: "Attivo", color: "#059669" },
        { value: "novita", label: "Novità", color: "#2563eb" },
        { value: "discontinuo", label: "Discontinuo", color: "#9ca3af" },
      ],
      fixtureTypeOptions: [
        { value: "", label: "— scegli —" },
        { value: "vaso", label: "Vaso", icon: "fa-toilet" },
        { value: "bidet", label: "Bidet", icon: "fa-water" },
        { value: "lavabo", label: "Lavabo", icon: "fa-droplet" },
        { value: "box doccia", label: "Box doccia", icon: "fa-shower" },
        { value: "piatto doccia", label: "Piatto doccia", icon: "fa-grip" },
        { value: "vasca", label: "Vasca", icon: "fa-bath" },
        {
          value: "mobile bagno",
          label: "Mobile bagno",
          icon: "fa-layer-group",
        },
        { value: "specchiera", label: "Specchiera", icon: "fa-image" },
        { value: "rubinetteria", label: "Rubinetteria", icon: "fa-faucet" },
        { value: "idraulica", label: "Idraulica", icon: "fa-wrench" },
        { value: "altro", label: "Altro", icon: "fa-circle-question" },
      ],
      subCategoryOptions: [
        { value: "Elementi Lineari", label: "Elementi Lineari" },
        { value: "Decori", label: "Decori" },
        { value: "Fondi", label: "Fondi" },
        { value: "Battiscopa", label: "Battiscopa" },
        { value: "Listelli", label: "Listelli" },
        { value: "Gradini", label: "Gradini" },
        { value: "Scalini", label: "Scalini" },
        { value: "Altri Pezzi Speciali", label: "Altri Pezzi Speciali" },
      ],
      fixturePositionOptions: [
        { value: "", label: "— scegli —" },
        { value: "sospeso", label: "Sospeso", icon: "fa-arrow-up" },
        { value: "terra", label: "A terra", icon: "fa-arrow-down" },
        { value: "mono-blocco", label: "Mono-blocco", icon: "fa-cube" },
        { value: "nessuno", label: "Nessuno", icon: "fa-ban" },
        { value: "altro", label: "Altro", icon: "fa-circle-question" },
      ],
      parquetMaterialOptions: [
        { value: "", label: "— nessuna —" },
        { value: "ROVERE", label: "Rovere" },
        { value: "TEAK", label: "Teak" },
        { value: "IROKO", label: "Iroko" },
        { value: "DOUSSIE", label: "Doussié" },
      ],
      parquetSceltaOptions: [
        { value: "", label: "— nessuna —" },
        { value: "CERCHIO", label: "Cerchio" },
        { value: "QUADRATO", label: "Quadrato" },
        { value: "TRIANGOLO", label: "Triangolo" },
      ],
      form: {
        itemCode: "",
        itemName: "",
        brand: "",
        serie: "",
        price: 0,
        articleStatus: "attivo",
        subCategory: "",
        formatLabel: "",
        thicknessMm: null,
        surface: "",
        color: "",
        piecesPerBox: null,
        sqmPerBox: null,
        boxQuantity: null,
        fixtureType: "",
        fixturePosition: "",
        finish: "",
        material: "",
        lengthMm: null,
        mlPerBox: null,
        widthCm: null,
        heightCm: null,
        specs: { scelta: "" },
        notes: "",
      },
    };
  },
  computed: {
    // true se il form differisce dallo snapshot iniziale (dati inseriti).
    hasUnsavedChanges() {
      if (!this.pristineFormSig) return false;
      return JSON.stringify(this.form) !== this.pristineFormSig;
    },
    category() {
      return decodeURIComponent(this.$route.params.category || "");
    },
    categoryGroup() {
      return getCategoryGroup(this.category);
    },
    tileGroup() {
      if (this.category !== "piastrelle") return null;
      const sub = this.form.subCategory;
      if (sub === "Elementi Lineari") return "linear";
      if (sub === "Decori" || sub === "Fondi") return "area";
      if (
        [
          "Battiscopa",
          "Listelli",
          "Gradini",
          "Scalini",
          "Altri Pezzi Speciali",
        ].includes(sub)
      )
        return "piece";
      return null;
    },
    derivedSalesUnit() {
      if (this.categoryGroup === "bath") return "PZ";
      if (this.category === "parquet") return "M2";
      const g = this.tileGroup;
      if (g === "linear") return "ML";
      if (g === "area") return "M2";
      if (g === "piece") return "PZ";
      return null;
    },
    priceLabel() {
      const su = this.derivedSalesUnit;
      if (su === "ML") return "Prezzo / ML";
      if (su === "M2") return "Prezzo / M²";
      if (su === "PZ") return "Prezzo / pz";
      return "Prezzo";
    },
    canSave() {
      if (!(this.form.itemName || "").trim()) return false;
      if (this.category === "piastrelle" && !this.form.subCategory)
        return false;
      if (this.category === "bagno" && !this.form.subCategory) return false;
      return true;
    },
  },
  methods: {
    goBack() {
      this.pendingNavigation = null;
      // Nessun dato inserito: torna indietro senza conferma.
      if (!this.hasUnsavedChanges) {
        this.navigationConfirmed = true;
        this.$router.back();
        return;
      }
      this.showBackModal = true;
    },
    // Guardia reload/chiusura tab nativa del browser: dialog nativo di
    // conferma solo se ci sono dati non salvati.
    handleBeforeUnload(e) {
      if (!this.hasUnsavedChanges) return;
      e.preventDefault();
      e.returnValue = "";
    },
    confirmGoBack() {
      this.navigationConfirmed = true;
      this.showBackModal = false;
      if (this.pendingNavigation) {
        this.$router.push(this.pendingNavigation);
      } else {
        this.$router.back();
      }
    },
    ...mapActions(["createItem"]),

    resetForm() {
      this.form = {
        itemCode: "",
        itemName: "",
        brand: "",
        serie: "",
        price: 0,
        articleStatus: "attivo",
        subCategory: "",
        formatLabel: "",
        thicknessMm: null,
        surface: "",
        color: "",
        piecesPerBox: null,
        sqmPerBox: null,
        boxQuantity: null,
        fixtureType: "",
        fixturePosition: "",
        finish: "",
        material: "",
        lengthMm: null,
        mlPerBox: null,
        widthCm: null,
        heightCm: null,
        specs: { scelta: "" },
        notes: "",
      };
    },

    async onSubmit() {
      const payload = {
        ...this.form,
        category: this.category,
        salesUnit: this.derivedSalesUnit,
      };

      // la giacenza si gestisce dal magazzino (modale in MagazzinoPage), non
      // dalla scheda articolo
      delete payload.boxQuantity;

      if (this.category === "parquet") {
        payload.specs = this.form.specs?.scelta
          ? { scelta: this.form.specs.scelta }
          : null;
      } else {
        delete payload.specs;
      }

      try {
        const res = await this.createItem(payload);
        this.$toast.success(res.data?.message || "Articolo creato!");
        this.resetForm();
        setTimeout(() => {
          this.navigationConfirmed = true;
          this.$router.push({
            name: "listini-category",
            params: { category: this.category },
          });
        }, 800);
      } catch (err) {
        if (
          err.response?.status === 409 &&
          err.response?.data?.code === "ITEM_CODE_DUPLICATE"
        ) {
          this.$toast.error(
            "Questo codice è già utilizzato da un altro articolo."
          );
        } else {
          this.$toast.error(
            err.response?.data?.message ||
              err.response?.data?.error ||
              "Errore durante la creazione."
          );
        }
      }
    },
  },
  mounted() {
    const sub = this.$route.query.subCategory;
    if (sub) this.form.subCategory = sub;
    // Snapshot dopo l'eventuale precompilazione da query string
    this.pristineFormSig = JSON.stringify(this.form);
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
};
</script>

<style src="@/css/CreateItemPage.css"></style>
